import { useState } from "react";
import AddMeetDetails from "./addmeetdetails";
import ToastMessage from "utils/muialerts/righttoptoast";

const GoogleMeetflow=()=>{
  const [alertmessage, setAlertMessage] = useState('');
  const [severity, setSeverity] = useState('success');
const [detailsmodal,setDetailsmodal]=useState(false)
  const [open, setOpen] = useState(false);
  const handleClose = (event, reason) => {
    if (reason === 'clickaway') {
      return;
    }
    setOpen(false);
  }; 
    return(<>
     <button
          onClick={() => {setDetailsmodal(true)}}
          className="w-full  sm:w-auto sm:min-w-[45%]  py-3 px-2 text-xs bg-gradient-to-r from-blue-500 to-indigo-600 text-white font-medium text-base rounded-lg flex items-center justify-center shadow-md hover:shadow-lg transform hover:scale-105 transition-transform duration-200"
        >
   Connect to Meeting
        </button>
    <AddMeetDetails 
    toastMessage={setAlertMessage}
    showtoast={setOpen}
    severity={setSeverity}
    isOpen={detailsmodal} close={setDetailsmodal}/>

     <ToastMessage message={alertmessage} severity={severity} open={open} handleClose={handleClose} />
    </>)
}
export default GoogleMeetflow;